import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import classes from "./SearchPage.module.css";
import SearchFilters from "./Search-filters/SearchFilters";
import SearchCards from "./SearchCards/SearchCards";
import CustomPagination from "components/CustomPagination/CustomPagination";
import CustomPaginations from "components/CustomPagination/CustomPagination";
import { useSelector } from "react-redux";
import { API_BASE_URL } from "configs/AppConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { debounce } from "lodash";
import useWindowDimensions from "hooks/useWindowDimensions";
import useWindowWidth from "helpers/useWindowWidth";
import { NavigationContext } from "App";
import SEO from "components/SEO/SEO";

function SearchPage() {
  const [appliedFilterData, setAppliedFilterData] = useState([]);
  const [catArray, setCatArray] = useState([]);
  const [eventArray, setEventArray] = useState([]);
  const [ratingArray, setRatingArray] = useState([]);
  const [priceArray, setPriceArray] = useState([]);
  const [proximityData, setProximitydata] = useState(null);
  const [priceValue, setPriceValue] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [extractedValues, setExtractedValues] = useState({});
  const [categoryData, setCategoryData] = useState([]);
  // const [filterValues, setFilterValues] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [venueData, setVenueData] = useState([]);
  const [totalCount, setTotalCount] = useState();
  const params = new URLSearchParams(window.location.search);
  const [currentPage, setCurrentPage] = useState(params?.get("page") || 1);
  const [loadExtractedValues, setLoadExtractedValues] = useState(false);
  const [error, setError] = useState(null);
  const [vendorData, setVendorData] = useState([]);
  const [searchInput, setSearchInput] = useState();
  const [paginationChange, setPaginationChange] = useState({});
  const { searchPageLoading, setSearchPageLoading } =
    useContext(NavigationContext);

  const location = useLocation();

  console.log("is visible", isVisible);
  const width = useWindowWidth();

  const limit = width > 1600 ? 20 : width > 1200 ? 15 : 16;

  const url = window.location.href;
  const user = useSelector((state) => state.user.user);
  const { latitude, longitude, place, pincode } = useSelector(
    (state) => state.filter
  );
  const [eventData, setEventData] = useState([]);
  const navigate = useNavigate();
  console.log("place is rrr", place, pincode);
  console.log("current page rrr", currentPage);

  useEffect(() => {
    const pagination = localStorage.getItem("search-page-pagination");
    if (pagination) {
      setPaginationChange(JSON.parse(pagination));
      setCurrentPage(JSON.parse(pagination).page);
    } else {
      setPaginationChange({ page: 1, limit: limit });
    }
  }, []);

  console.log("pagination fetched rrr", paginationChange, venueData);

  useEffect(() => {
    setLoadExtractedValues(false);
    // Extract values using URLSearchParams
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const values = {};

    params.forEach((value, key) => {
      if (key == "latitude" || key == "longitude" || key == "range") {
        values[key] = Number(value);
      } else {
        values[key] = value;
      }
    }); //create an object from href

    if (values?.latitude) {
      delete values["latitude"];
    }
    if (values?.longitude) {
      delete values["longitude"];
    }
    if (values.search) {
      setSearchInput(values.search);
    }

    console.log("values trt", values);

    // Update state with extracted values
    setExtractedValues(values); //store the created object to extracted values
    setLoadExtractedValues(true);
  }, [location.search]);

  const fetchcategories = async () => {
    const response = await fetch(`${API_BASE_URL}category/get/all/admin`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${user.sessionToken}`,
      },
      // body: JSON.stringify(),
    });

    const data = await response.json();
    setCategoryData(
      data.data.map((item) => ({ label: item.name, value: item._id }))
    );
    // setCategoryValues(data.data);
    console.log("response", data);
    if (!response.ok) {
      // message.error(data.message ? data.message : "Invalid Email or Password");
      throw new Error(data.message);
    }

    return data;
  };

  const fetchVendors = async () => {
    const response = await fetch(`${API_BASE_URL}user/vendors/active`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${user.sessionToken}`,
      },
      // body: JSON.stringify(),
    });

    const data = await response.json();
    setVendorData(
      data.data.map((item) => ({ label: item.name, value: item._id }))
    );
    // setCategoryValues(data.data);
    console.log("response", data);
    if (!response.ok) {
      // message.error(data.message ? data.message : "Invalid Email or Password");
      throw new Error(data.message);
    }

    return data;
  };

  // useEffect(()=>{
  //   setPaginationChange({page: 1, limit: 20})

  // },[location.search])

  const fetchVenues = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // smooth scroll to top
    let pageValue;
    let limitValue;
    //   const currentQuery = location.search;
    //   if (prevQueryRef.current !== currentQuery) {
    //     pageValue= 1;
    //     limitValue = 20;
    //     prevQueryRef.current = currentQuery; // update reference for future checks
    //   }else{
    pageValue = paginationChange.page;
    limitValue = paginationChange.limit;
    // }
    setError(null);
    setVenueData([]);
    setLoading(true);
    console.log("search has query ?", location.search);

    const queryString = Object.keys(extractedValues) //to pass query params to api from extracted values
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(
            extractedValues[key]
          )}`
      )
      .join("&");

    console.log("query string rrr", queryString);
    // if (queryString?.includes("search")) {
    setSearchPageLoading(true);
    // }

    // if (latitude !== undefined) {
    //   queryString += `&latitude=${latitude}`;
    // }

    // if (longitude !== undefined) {
    //   queryString += `&longitude=${longitude}`;
    // }

    let response = {};

    if (
      latitude &&
      longitude &&
      !extractedValues.latitude &&
      !extractedValues.longitude
    ) {
      response = await fetch(
        // `${API_BASE_URL}listing/get/all/public?${queryString}&latitude=${latitude}&longitude=${longitude}&page=${pageValue || 1
        `${API_BASE_URL}listing/get/all/public?${queryString}${queryString ? '&' : ''}serviceLocation=${pincode}&page=${
          pageValue || 1
        }&limit=${limitValue || limit}&${
          extractedValues?.range ? "" : "range=10"
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${user.sessionToken}`,
          },
          // body: JSON.stringify({
          //   page: currentPage,
          //   limit: itemsCountPerPage,

          // }),
        }
      );
    } else {
      response = await fetch(
        `${API_BASE_URL}listing/get/all/public?${queryString}&page=${pageValue}&limit=${limitValue}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${user.sessionToken}`,
          },
          // body: JSON.stringify({
          //   page: currentPage,
          //   limit: itemsCountPerPage,

          // }),
        }
      );
    }

    const data = await response.json();
    if (data?.error) {
      console.log("response not ok");
      setError("No Data Found");
      setLoading(false);
      setSearchPageLoading(false);
    }
    if (data?.data?.length == 0) {
      window.scrollTo({ top: 0, behavior: "smooth" }); // smooth scroll to top
    }
    if (data?.success) {
      setTotalCount(data?.total);

      // setCategoryData(
      //   data.data.map((item) => ({ label: item.name, value: item._id }))
      // );
      setVenueData(
        data.data.map((item) => ({
          title: item.name,
          slug: item?.slug,
          city: item.location.locationName,
          state: "Kerala",
          price: item?.availableDates?.[0]?.intervals?.[0]?.price ?? "",
          strikePrice: 15000,
          review: 4.7,
          img: item.images[0],
          categoryName: item.categoryName,
          _id: item._id,
          showPrice: item?.showPrice == "Yes" ? true : false,
          listingType: item?.listingType,
        }))
      );
      setSearchPageLoading(false);
      // window.scrollTo({ top: 0, behavior: "smooth" }); // smooth scroll to top
    } else {
      setSearchPageLoading(false);
      // window.scrollTo({ top: 0, behavior: "smooth" }); // smooth scroll to top
    }
    console.log("listing response", data);
    if (!response.ok) {
      setSearchPageLoading(false);
      // message.error(data.message ? data.message : "Invalid Email or Password");
      throw new Error(data.message);
      // window.scrollTo({ top: 0, behavior: "smooth" }); // smooth scroll to top
    }

    setLoading(false);
    return data;
  };

  const debouncedFetchVenues = useCallback(
    debounce(() => {
      fetchVenues();
    }, 300), // Adjust delay as needed
    [extractedValues, latitude, paginationChange] // dependencies
  );

  useEffect(() => {
    if (loadExtractedValues && paginationChange) {
      debouncedFetchVenues();
    }
    return () => {
      debouncedFetchVenues.cancel();
    };
  }, [debouncedFetchVenues, loadExtractedValues, paginationChange]);

  // useEffect(() => {
  //   if (loadExtractedValues && paginationChange) {
  //     fetchVenues();
  //   }
  // }, [extractedValues, latitude, paginationChange]);

  console.log("extracted values", extractedValues);

  useEffect(() => {
    fetchcategories();
    fetchVendors();
  }, [user]);

  //fetch events

  const fetchEvents = async () => {
    const response = await fetch(`${API_BASE_URL}eventType/get/all`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${user.sessionToken}`,
      },
      // body: JSON.stringify(),
    });

    const data = await response.json();
    setEventData(
      data.data.map((item) => ({ value: item.name, label: item.name }))
    );
    console.log("response", data);
    if (!response.ok) {
      // message.error(data.message ? data.message : "Invalid Email or Password");
      throw new Error(data.message);
    }

    return data;
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const removeFilter = (name, value) => {
    console.log("name and value", name, value);
    setAppliedFilters(appliedFilters.filter((item) => item.name != name));

    if (name == "range") {
      setExtractedValues((prevValues) => ({
        ...prevValues,
        [name]: undefined, // Using square brackets to access the property dynamically
      }));
    } else {
      const updatedValues = { ...extractedValues };
      delete updatedValues[name];
      setExtractedValues(updatedValues);
    }
    if (name == "search") {
      setSearchInput(null);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if ([...searchParams].length === 0) {
      setAppliedFilters([]);
    } else {
      // You can parse and apply filters if needed
      console.log("Query params:", Object.fromEntries(searchParams));
    }
  }, [location]);

  // console.log("applied filters are", appliedFilters);

  return (
    <>
      <SEO />
      <div className={classes.searchOuter}>
        <SearchFilters
          appliedFilterData={appliedFilterData}
          setAppliedFilterData={setAppliedFilterData}
          removeFilter={removeFilter}
          catArray={catArray}
          setCatArray={setCatArray}
          eventArray={eventArray}
          setEventArray={setEventArray}
          ratingArray={ratingArray}
          setRatingArray={setRatingArray}
          proximityData={proximityData}
          setProximitydata={setProximitydata}
          priceValue={priceValue}
          setPriceValue={setPriceValue}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          categoryData={categoryData}
          extractedValues={extractedValues}
          setExtractedValues={setExtractedValues}
          // filterValues={filterValues}
          // setFilterValues={setFilterValues}
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          eventData={eventData}
          vendorData={vendorData}
          place={place}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          paginationChange={paginationChange}
          setPaginationChange={setPaginationChange}
          limit={limit}
          searchLoading={searchPageLoading}
        />

        <SearchCards
          appliedFilterData={appliedFilterData}
          setAppliedFilterData={setAppliedFilterData}
          removeFilter={removeFilter}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          loading={loading}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalCount={totalCount}
          itemsCountPerPage={limit}
          venueData={venueData}
          setVenueData={setVenueData}
          error={error}
          paginationChange={paginationChange}
          setPaginationChange={setPaginationChange}
        />
      </div>
    </>
  );
}

export default SearchPage;
